/* tslint:disable */
import { Injectable } from '@angular/core';
import { HttpClient, HttpRequest, HttpResponse, HttpHeaders } from '@angular/common/http';
import { BaseService as __BaseService } from '../base-service';
import { ApiConfiguration as __Configuration } from '../api-configuration';
import { StrictHttpResponse as __StrictHttpResponse } from '../strict-http-response';
import { Observable as __Observable } from 'rxjs';
import { map as __map, filter as __filter } from 'rxjs/operators';

import { SenatorTrades } from '../models/senator-trades';
import { SenatorQualityGateFilterModel } from '../models/senator-quality-gate-filter-model';
@Injectable({
  providedIn: 'root',
})
class SenatorRecentlyMergedAssetClassesTradesService extends __BaseService {
  static readonly getSenatorRecentlyMergedAssetClassesTradesPath = '/senatorRecentlyMergedAssetClasses';

  constructor(
    config: __Configuration,
    http: HttpClient
  ) {
    super(config, http);
  }

  /**
   * @param senatorQualityGateFilterModel undefined
   * @return Returns list of politician trades that needs to be checked.
   */
  getSenatorRecentlyMergedAssetClassesTradesResponse(senatorQualityGateFilterModel: SenatorQualityGateFilterModel): __Observable<__StrictHttpResponse<Array<SenatorTrades>>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    __body = senatorQualityGateFilterModel;
    let req = new HttpRequest<any>(
      'POST',
      this.rootUrl + `/senatorRecentlyMergedAssetClasses`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<Array<SenatorTrades>>;
      })
    );
  }
  /**
   * @param senatorQualityGateFilterModel undefined
   * @return Returns list of politician trades that needs to be checked.
   */
  getSenatorRecentlyMergedAssetClassesTrades(senatorQualityGateFilterModel: SenatorQualityGateFilterModel): __Observable<Array<SenatorTrades>> {
    return this.getSenatorRecentlyMergedAssetClassesTradesResponse(senatorQualityGateFilterModel).pipe(
      __map(_r => _r.body as Array<SenatorTrades>)
    );
  }
}

module SenatorRecentlyMergedAssetClassesTradesService {
}

export { SenatorRecentlyMergedAssetClassesTradesService }
